import React, { useState, useEffect } from 'react'
import { v4 as uuid } from 'uuid'
import Country from './Country'
import { arraySort } from '../Utils/index'
import { regions, getRegionCountries } from '../Data'

const defaultRegion = regions.world

const CountryList = ({ filter, searchString, dataLocal }) => {
  const [countries, setCountries] = useState(
    arraySort(getRegionCountries(defaultRegion), 'name.common')
  )

  let countriesFiltered = dataLocal ? dataLocal : []

  useEffect(() => {
    const getFilteredCountries = async (filter) => {
      setCountries(arraySort(getRegionCountries(filter), 'name.common'))
    }
    getFilteredCountries(filter)
  }, [filter, setCountries])

  const getSearchedCountries = (searchString) => {
    const regExSearch = new RegExp(searchString, 'i')
    const regExWordSearch = new RegExp(`\\b${searchString}\\b`, 'i')

    return countries.filter((country) => {
      let languages = []
      if (country.languages) {
        languages = Object.values(country.languages).join(' ')
      }

      return (
        regExSearch.test(country.name.common) ||
        regExSearch.test(country.name.official) ||
        regExSearch.test(country.capital) ||
        regExWordSearch.test(country.cca3) ||
        regExSearch.test(country.demonym) ||
        regExSearch.test(country.name.nativeName) ||
        regExSearch.test(languages)
      )
    })
  }

  if (countries.length !== 0) {
    countriesFiltered = getSearchedCountries(searchString).map((country) => {
      return (
        <Country key={uuid()} countries={countries.length} country={country} />
      )
    })
  }

  return (
    <main aria-label='Country list' className='CountryList'>
      {countriesFiltered}
    </main>
  )
}

export default CountryList
